import Mode from './Mode';

export default Mode;